import React, { useContext } from "react";
import { View, StyleSheet, Platform } from "react-native";

import Icons from "../../common/icons";

import AppTheme from "../../AppTheme";
import ReflectionContext from "../ReflectionContext";
import ExportIcon from "../../common/ExportIcon";
import ReviewReportsIcon from "../../common/ReviewReportsIcon";
import appPages from "../../../../appPages";
import AutoTrackHeader from "../../common/header/AutoTrackHeader";
import Header from "../../common/header/index";

import VIEW_MODES from "./viewModes";
import ListIcon from "../../common/ActionsMenuButton/icons/ListIcon";
import InsightsWhiteIcon from "../../common/ActionsMenuButton/icons/InsightsWhiteIcon";
import ReflectionHeaderToggle from "./ReflectionHeaderToggle";

export default function ReflectionHeader(props) {
  const {
    controller,
    title,
    subTitle = "",
    isLoading = false,
    header = null,
    onIconClick,
  } = props;

  const context = useContext(ReflectionContext) || {};
  const {
    viewMode,
    showTutorials,
    showReflectionTutorials,
    goBackOneStep,
    filterByDate,
    isReportMode,
    createNewReport,
    changeViewMode,
    isAutoTrackMode = false,
    isComparisonPage = false,
    isAdmin,
  } = context;

  const refectionMood = header
    ? header.days
      ? header.days[0].gem?.mood
      : null
    : null;

  const goToReports = () => {
    controller.navigate(appPages.receivedReports, {}, true);
  };

  const showJournalIcon =
    !isAutoTrackMode &&
    header &&
    viewMode == VIEW_MODES.chartView &&
    !isReportMode;

  const insightsView = viewMode == VIEW_MODES.insights;

  return (
    <View>
      {isAutoTrackMode ? (
        <AutoTrackHeader
          context={context}
          subTitle="Time confirmed from integrations & predictions"
        />
      ) : null}

      {/* Header */}
      <Header
        controller={controller}
        title={title}
        subTitle={subTitle}
        isLoading={isLoading}
        style={styles.container}
        goBack={
          isComparisonPage ||
          isReportMode ||
          showTutorials ||
          showReflectionTutorials
            ? goBackOneStep
            : null
        }
        iconTag={
          isComparisonPage ? null : isAutoTrackMode ? null : insightsView ? (
            <ListIcon onPress={() => changeViewMode(VIEW_MODES.tableView)} />
          ) : (
            <InsightsWhiteIcon
              onPress={() => changeViewMode(VIEW_MODES.insights)}
            />
          )
          /*
          (
            <ReviewReportsIcon onPress={goToReports} width={20} height={20} />
          )
          */
        }
        iconTag2={
          isComparisonPage ? null : isAutoTrackMode ? null : insightsView ? (
            <ReviewReportsIcon onPress={goToReports} width={20} height={20} />
          ) : (
            <ExportIcon
              onPress={() => createNewReport()}
              width={20}
              height={20}
            />
          )
        }
        iconTag3={
          isComparisonPage ? null : showJournalIcon ? (
            <Icons.Journal
              onPress={onIconClick}
              mood={refectionMood}
              width={20}
              height={20}
              fillColor={AppTheme.iconBlack}
            />
          ) : null
        }
      >
        {header ? (
          <ReflectionHeaderToggle
            viewMode={viewMode}
            isAutoTrackMode={isAutoTrackMode}
            days={header?.days}
            timeline={header?.timeline}
            onDateChanged={filterByDate}
          />
        ) : null}
      </Header>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        minHeight: 88,
        paddingTop: 10,
        paddingBottom: 0,
      },
      ios: {
        minHeight: 120,
        paddingTop: 52,
      },
      android: {
        paddingTop: 16,
      },
    }),
  },
});
